<section id="home" class="sc-scroll-bar">
    <!--MAIN-->
        <sc-external-url
                            [url]="iframeBodySRC">
        </sc-external-url>
</section>
